import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

export function provideStoreDevtools(_config?: unknown): EnvironmentProviders {
  return makeEnvironmentProviders([]);
}
